import { CORRECTIVE_ACTIONS_COUNT_LOAD_SUCCESS } from "../constants/actionTypes";

export default (state = 0, action) => {
  switch (action.type) {
    case CORRECTIVE_ACTIONS_COUNT_LOAD_SUCCESS:
      return action.count;
    default:
      return state;
  }
};
